import React, { ReactNode } from 'react';

interface TreeItemWrapperProps {
  children: ReactNode;
  paddingClass: string;
  onClick: () => void;
  maxWidth?: string;
}

const TreeItemWrapper: React.FC<TreeItemWrapperProps> = ({
  children,
  paddingClass,
  onClick,
  maxWidth = '80%'
}) => {
  return (
    <button
      type="button"
      className={`w-full py-3 ${paddingClass} pr-1 text-left flex justify-between items-center cursor-pointer`}
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          onClick();
        }
      }}
      tabIndex={0}
    >
      <div className="overflow-hidden" style={{ maxWidth }}>
        {children}
      </div>
    </button>
  );
};

export default TreeItemWrapper;
